"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ImageUpload = function ImageUpload(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.36954 6C3.62095 6 3 6.6522 3 7.43845V18.9463C3 19.7326 3.62095 20.3848 4.36954 20.3848H19.6305C20.379 20.3848 21 19.7326 21 18.9463V7.43845C21 6.6522 20.379 6 19.6305 6H4.36954ZM4.36954 7.23306H19.6305C19.7491 7.23306 19.8262 7.31405 19.8262 7.43862V15.6072L16.867 13.1218C16.6733 12.9573 16.3765 12.9437 16.17 13.0897L13.3942 15.0934L9.62787 11.889C9.50777 11.7862 9.34782 11.7366 9.19373 11.7541C9.09724 11.7664 9.00389 11.8042 8.92473 11.8633L4.17386 15.3051V7.43824C4.17386 7.31368 4.25097 7.23269 4.36957 7.23269L4.36954 7.23306ZM13.3696 8.87708C12.404 8.87708 11.6088 9.7125 11.6088 10.7265C11.6088 11.7407 12.4042 12.5759 13.3696 12.5759C14.3352 12.5759 15.1304 11.7405 15.1304 10.7265C15.1304 9.71232 14.335 8.87708 13.3696 8.87708ZM13.3696 10.1101C13.7007 10.1101 13.9566 10.3789 13.9566 10.7267C13.9566 11.0744 13.7007 11.3432 13.3696 11.3432C13.0385 11.3432 12.7826 11.0744 12.7826 10.7267C12.7826 10.3789 13.0385 10.1101 13.3696 10.1101ZM9.2364 13.1413L13.0027 16.3393C13.1964 16.5038 13.4932 16.5175 13.6997 16.3714L16.4693 14.3677L19.826 17.1869V18.9464C19.826 19.0708 19.7489 19.1519 19.6303 19.1519H4.36934C4.25074 19.1519 4.17363 19.071 4.17363 18.9464V16.808L9.2364 13.1413Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: "0.5"
  }));
};

ImageUpload.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
ImageUpload.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = ImageUpload;
exports.default = _default;